module.exports = __webpack_public_path__ + "fonts/feather_icon.a940fe89.ttf";